import React, { useState } from 'react'
import Loading from "../Images/loading.gif"
import {pow,bignumber,mod} from "mathjs"
import "../CSS/RSA.css"
function RSA() {
  const [p,setP] = useState(0);
  const [q,setQ] = useState(0);
  const [plain,setPlain] = useState(0);
  const [isLoading,setIsLoading] = useState(false);
  const [data,isData] = useState(0);
  const [e,setE] = useState(0);
  const [d,setD] = useState(0);
  const [c,setC] = useState(0);
  const [decrypted,showDecrypted] = useState(false);
  const [present,setPresent] = useState("find d")


const isPrime =  (n) => {
    var j;
  for (j = 2; j < n; j++) {
    if (n % j === 0) {
      return false;
    }
  }

  return true;
}
const gcd =  (a, b) => {
  if (a === 0)
    return b;
  return gcd(b % a, a);
}

const find_e = (phi) => {
  //this will find e 
  var e;
    var i;
  for (i = 2; i < phi; i++) {

    if ( isPrime(i)) {
      if (gcd(i, phi) === 1) {
        return i;
      }
    }

  }

}
const find_d =  (e, phi) => {
  //(d*e)mod(phi)===1
  var t = 2;
  while (1) {
    if (((t * e) % phi) === 1)
    {
      setD(t);
      return t;
    }
      
    t++;
  }
}

const encrypt =  (plainText, e, n) => {
  var res = 1,i;
  for (i = 1; i <= e; i++) {
    res *= plainText;
  
  }
  res = (res) % n;
  setC(res);
  return res;
}


const decrypt = (c, d, n) => {
    c=bignumber(c);
    d=bignumber(d);
    
  var res = pow(c,d)
    console.log(res+"nee yakka");
    console.log("");
    var ans = mod(res,bignumber(n));
    console.log(ans)
   return mod(res,n);




}




// var p = 23
// var q = 19
// var n = p * q;
// var phi = (p - 1) * (q - 1)
// var plaintext =11





//order of calling 
//1.find_e
//2.find_d
//3.encrypt
//4.decrypt


//pow(c,d)mod(n)=1


 
  const send =  ()=>
  {
          setPresent("find d");
          showDecrypted(false);
          setC(0);
          setD(0);
          var phi = (p-1) *(q-1);
          var n=p*q;
          setE(find_e(phi));
          console.log(e)
          //setTimeout( setD(await find_d(e,phi)),1000);
          //setTimeout(setC(await encrypt(plain,e,n)),4000);
         
        
         
  }


  return (
      <div className='rsa'>

     {
      isLoading? <img className='loading' src={Loading}></img>:<></>
     }
        <h1 className='header'>RSA algorithm</h1>
        <div className='row-rsa'>
            <div className='col-rsa-send'>
                <h1 className='header2'>Sender</h1>
                <div className='p-q'>
               <div>
               <h1 className='labels'>Enter p value:</h1>
                <input  onChange={(e)=>setP(e.target.value)}></input>
               </div>
               <div>
               <h1 className='labels'>Enter q value:</h1>
                <input  onChange={(e)=>setQ(e.target.value)}></input>
               </div>
                </div>

            <div className='plaintext'>
                          <h1 className='labels'>Enter plain text:</h1>
                        <input onChange={(e)=>setPlain(e.target.value)}></input>
            </div>
         <div className='div-send'>
         <button className='send' onClick={()=>{
           setIsLoading(true);
            setTimeout(function(){setIsLoading(false); ;send();
              },1000);
            
            
           
          
         }} >Send/Encrypt</button>
         </div>
            </div>
            <div className='col-rsa-recieve'>
            <h1 className='header2 '>Receiver</h1>
            {
              true?<div>
                <div className='p-q'>
               <div>
               <h1 className='labels'>e value:</h1>
                <input disabled placeholder={e} ></input>
               </div>
               <div>
               <h1 className='labels'>d value:</h1>
                <input disabled  placeholder={d}></input>
               </div>
               <div>
               <h1 className='labels'>encrypted value:</h1>
                <input disabled  placeholder={c} ></input>
               </div>
                </div>
                <div className='div-send'>
         <button className='send' onClick={()=>{
                if(present==="find d")
                
                {
                  var phi=(p-1)*(q-1);
                  console.log(phi);
                  console.log(p,q);
                  find_d(e,phi);
                  
                  setPresent("find c");
                }

                if(present==="find c")
                {
                  var n=p*q;
                  encrypt(plain,e,n);
                  setPresent("decrypt");
                }
                if(present==="decrypt")
                {
                  showDecrypted(true);
                }
                
              
         }} >{present}</button>
        
         </div>
         {
          decrypted?  <div className='decrypt'>
          <h1 className='labels'>encrypted value:</h1>
           <input disabled  placeholder={plain}></input>
          </div>:<></>
         }

              </div>:<></>
            }


            </div>
        </div>

      </div>
  )

}
export default RSA